<template>
  <div>
    <Label
      v-bind="labelProps"
      :html-for="id"
      :bold="labelBold"
      v-if="label"
      :disabled="disabled"
    >
      {{ label }}
    </Label>
    <input
      type="tel"
      class="form-control"
      :class="inputClass"
      :value="formattedValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @change="change"
      @keypress.enter.prevent="hamdleOnEnter"
      @keydown="$event.key === '-' && $event.preventDefault()"
      v-money="options"
    />
    <div
      class="input-description input-margin"
      v-if="description"
      :class="descriptionClass"
    >
      {{ description }}
    </div>
  </div>
</template>

<script>
import { Label } from '../../../../../../components/Form';

export default {
  name: 'InputMoney',
  components: {
    Label,
  },
  props: {
    label: {
      type: String,
    },
    labelProps: {
      type: Object,
    },
    labelBold: {
      type: Boolean,
      default: () => false,
    },
    inputClass: {
      type: String,
    },
    value: {
      required: true,
      type: [Number, String],
      default: 0,
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    onEnter: {
      type: Function,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => ({
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: true,
      }),
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      formattedValue: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        const formatted = newValue;
        if (formatted !== this.formattedValue) {
          this.formattedValue = formatted;
        }
      },
    },
  },
  methods: {
    hamdleOnEnter() {
      this.onEnter();
    },
    change(evt) {
      this.$emit(
        'input',
        this.masked ? evt.target.value : evt.target.value,
        this.precision,
      );
    },
  },
  computed: {
    descriptionClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },
  },
};
</script>
